import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import {AppRoutingModule} from '../app-routing.module';
import { FormsModule } from '@angular/forms';
import { QuoteEstimatorComponent } from "./quote-estimator.component";
import {MaterialModule} from '../shared/material/material.module';
import {IwgcommonModule} from '../iwgcommon/iwgcommon.module';
import {UserService} from '../shared/services/user.service';
import { SharedPipesModule } from '../shared/pipes/sharedpipes.module';
import { QuotesService } from '../shared/services/quotes.service';

@NgModule({
  declarations: [
    QuoteEstimatorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    IwgcommonModule,
    FlexLayoutModule,
    AppRoutingModule,
    SharedPipesModule
  ],
  providers: [UserService, QuotesService],
  exports:[
    QuoteEstimatorComponent
  ]
})
export class QuoteEstimatorModule { }
